<template>
  <Dialog ref="dialog" :defaultWidth="1200">
    <div class="mdc-dialog__content">
      <iframe :src="iframeLink" class="noselect" />
    </div>
    <div class="mdc-dialog__actions">
      <Button data-mdc-dialog-action="discard" data-mdc-dialog-initial-focus>
        Close
      </Button>
    </div>
  </Dialog>

  <div
    :class="
      'mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop' +
      (isOdd ? ' casestudies__odd--left' : '')
    "
  >
    <div class="casestudies__token">
      <img :src="logo" :alt="title + ' logo'" />
      <h3>{{ title }}</h3>
    </div>
    <p>
      <slot></slot>
    </p>
    <Button outlined :link="threadLink" target="_blank">
      Read the thread
    </Button>
    <div
      v-if="featuredIn && featuredIn.length > 0"
      class="casestudies__featured-in"
    >
      <h4>Featured in:</h4>
      <div class="casestudies__featured-logos">
        <a
          v-for="media in featuredIn"
          :key="media.name"
          :href="media.link"
          :title="media.name"
          target="_blank"
          class="casestudies__featured-logo"
          :style="{
            backgroundColor: media.color ? media.color : '#ffffff',
          }"
          v-scrollreveal="{ delay: 100 }"
        >
          <img :src="media.logo" :alt="media.name + ' logo'" />
        </a>
      </div>
    </div>
  </div>
  <div
    class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-7-desktop casestudies__preview-container sr_prevent_flickering noselect"
    v-scrollreveal="{ delay: 200 }"
    @click="$refs.dialog.open()"
  >
    <img
      :src="thumbnail"
      class="casestudies__preview"
      :alt="title + ' bubble map preview'"
    />
    <div class="casestudies__tryme">Try me!</div>
  </div>
  <div
    v-if="isOdd"
    class="mdc-layout-grid__cell mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-5-desktop casestudies__odd--right"
  >
    <div class="casestudies__token">
      <h3>{{ title }}</h3>
      <img :src="logo" :alt="title + ' logo'" />
    </div>
    <p>
      <slot></slot>
    </p>
    <Button outlined :link="threadLink" target="_blank">
      Read the thread
    </Button>
    <div
      v-if="featuredIn && featuredIn.length > 0"
      class="casestudies__featured-in"
    >
      <h4>Featured in:</h4>
      <div class="casestudies__featured-logos">
        <a
          v-for="media in featuredIn"
          :key="media.name"
          :href="media.link"
          :title="media.name"
          target="_blank"
          class="casestudies__featured-logo"
          :style="{
            backgroundColor: media.color ? media.color : '#ffffff',
          }"
          v-scrollreveal="{ delay: 100 }"
        >
          <img :src="media.logo" :alt="media.name + ' logo'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Dialog from "@/components/atoms/material/Dialog.vue";
import Button from "@/components/atoms/material/Button.vue";

export default {
  name: "CaseStudy",
  components: {
    Dialog,
    Button,
  },
  props: {
    title: String,
    logo: String,
    thumbnail: String,
    threadLink: String,
    iframeLink: String,
    featuredIn: {
      type: Array,
      default: () => [],
    },
    isOdd: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/variables";

.casestudies__studies {
  margin-bottom: 50px;
  max-width: 1100px;
  margin: auto;
}

.casestudies__token {
  display: flex;
  align-items: center;

  img {
    height: 50px;
    width: 50px;
    border-radius: 100px;
    margin-right: 10px;
  }

  h3 {
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.2rem;
    font-size: 1.5rem;
  }
}

p {
  color: white;
  font-size: 1.5rem;
}

.casestudies__featured-in {
  margin-top: 20px;

  h4 {
    color: rgba(255, 255, 255, 0.8);
    font-size: 1rem;
    font-weight: 400;
    margin: 0 0 10px 0;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
  }
}

.casestudies__featured-logos {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.casestudies__featured-logo {
  transition: transform 200ms ease-in-out;
  padding: 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: translateY(-2px);
  }

  img {
    height: 24px;
    width: auto;
    border-radius: 4px;
  }
}

.casestudies__preview {
  width: 100%;
  height: 100%;
  min-height: 300px;
  border-radius: 10px;
  object-fit: cover;
  position: relative;
  transition: transform 200ms ease-in-out;
  aspect-ratio: 1480 / 790;
  object-fit: cover;
}

.casestudies__tryme {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 4px;
  font-weight: 700;
  font-size: 1.2rem;
  background-color: rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  border-radius: 0 0 10px 10px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 200ms ease-in-out, transform 200ms ease-in-out;
}

.casestudies__preview-container {
  position: relative;
  cursor: pointer;

  &:hover {
    .casestudies__tryme,
    .casestudies__preview {
      color: $theme-blue;
      transform: translateY(-10px);
    }
  }
}

.casestudies__odd--right {
  display: none;
  text-align: right;

  .casestudies__token {
    justify-content: flex-end;

    img {
      margin-right: 0px;
      margin-left: 10px;
    }
  }

  .casestudies__featured-logos {
    justify-content: flex-end;
  }
}

.mdc-dialog__content {
  iframe {
    width: 100%;
    height: 350px;
    border: none;
    border-radius: 10px;
    background-color: $theme-almost-black;
  }
}

@media (min-width: $mdc-grid-tablet) {
  .mdc-dialog__content {
    iframe {
      height: 450px;
    }
  }
}

@media (min-width: $mdc-grid-desktop) {
  .casestudies__odd--left {
    display: none;
  }
  .casestudies__odd--right {
    display: block;
  }
  iframe {
    margin-bottom: 20px;
  }
  .casestudies__studies {
    row-gap: 80px;
  }

  .mdc-dialog__content {
    iframe {
      height: 600px;
    }
  }
}
</style>
